import { render, staticRenderFns } from "./PWAController.vue?vue&type=template&id=a4fb2856&scoped=true"
import script from "./PWAController.vue?vue&type=script&lang=js"
export * from "./PWAController.vue?vue&type=script&lang=js"
import style0 from "./PWAController.vue?vue&type=style&index=0&id=a4fb2856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb2856",
  null
  
)

export default component.exports